<div class="no-more-tables maxHeight" style="background-color: #fff;">
    <table class="table table-bordered mb-0 table-hover" *ngIf="files.length">
        <thead style="background-color: #f2f2f2">
            <tr>
                <th style="width: 30px;"></th>
                <th>Tên</th>
                <th>Kích thước</th>
                <th>Ngày tạo</th>
                <th *ngIf="!viewOnly" colspan="2">Thao tác</th>
            </tr>
        </thead>
        <tr *ngFor="let item of files">
            <td class="vs-hidden-print">
                <label class="vs-custom-checkbox">
                    <input class="__checkbox" type="checkbox" (change)="checkItem(item)" [(ngModel)]="item.checked" value="{{item.id}}">
                    <span class=" __mark"></span>
                </label>
            </td>

            <!-- <td class="text-center tdcheck">
                <label class="custom-checkbox ma3" *ngIf="item.isFolder != true">
                    <input type="checkbox" (change)="checkItem(item)" [(ngModel)]="item.checked" value="{{item.id}}"
                        class="custom-control-input">
                    <span class="custom-control-indicator cust"></span>
                </label>
            </td> -->
            <td>
                <a (click)="onItemClick(item)" target="_blank">
                    <i class="fa-light fa-folder pr-5" *ngIf="item.isFolder == true"></i>
                    
                  <ng-container *ngIf="item.isFolder != true">
                      <img *ngIf="item.type == 1" src="{{urlImageAvatar(item.path)}}" class="pr-5"/> 
                      <img *ngIf="item.type != 1" src="/assets/images/file-ext/icon{{item.extention}}.png" class="pr-5"/>
                  </ng-container>
                    {{item.fileName}}
                </a>
            </td> 
            <td>
                <p *ngIf="item.isFolder != true">{{item.size | psFileSize }} </p>
            </td>
            <td>
                {{item.createdDate | date : 'dd/MM/yyyy HH:mm a':'UTC'}}
            </td>
            <td data-title="Open" class="numeric" *ngIf="!viewOnly" style="width: 20px;">
                <a *ngIf="item.isFolder != true" (click)="downloadFile(item)" style="margin-right:10px;">
                    <i class="fa-light fa-download" style="font-size: 1.2em"></i>
                </a>
            </td>
            <td data-title="Open" class="numeric" *ngIf="!viewOnly" style="width: 30px;">
                <span *ngIf="isMngFile">
                    <a [hidden]="item.isHidden" class="text text-danger" confirmSwal (confirm-click)="deleteFile(item)" confirm-text="{{item.fileName}}"
                        confirm-title="Bạn có chắc chắn xóa không!" style="margin-right:10px;">
                        <i class="fa-light fa-trash" style="font-size: 1.2em"></i>
                    </a>
                </span>
                <span *ngIf="!isMngFile">
                    <a [hidden]="item.isHidden" class="text text-danger" confirmSwal (confirm-click)="deleteFileTemp(item)" confirm-text="{{item.fileName}}"
                        confirm-title="Bạn có chắc chắn xóa không!" style="margin-right:10px;">
                        <i class="fa-light fa-trash" style="font-size: 1.2em"></i>
                    </a>
                </span>
            </td>
        </tr>
    </table>
    <div class="alert ui-state-default" *ngIf="!files.length">
        Không có file đính kèm
    </div>
</div>


<!-- <ng-template ngbModalContainer></ng-template>
<ng-template #fileViewer let-c="close" let-d="dismiss">
    <div class="modal-header ">
        <h6 class="modal-title text-uppercase ">Xem nội dung file</h6>
        <button type="button " class="close " aria-label="Close " (click)="onClose()">
            <span aria-hidden="true ">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <file-viewer [FileName]="selectedFile.rawFileName" [FileUrl]="linkView"></file-viewer>
    </div>
</ng-template> -->